import React from "react";
import NewDatagrid from "./GradeScaleDatagrid.js";
import LegacyDatagrid from "./GradeScaleDatagridLegacy.js";
import { getUseDataGridGradeScales } from "../../modules/Utils";

const GradeScaleDatagrid = props => {
  if (getUseDataGridGradeScales()) {
    return <NewDatagrid {...props} />;
  }
  return <LegacyDatagrid {...props} />;
};

export default GradeScaleDatagrid;
